import { useEffect, useRef } from 'react';

/**  */
const useTextAreaAutoHeight = (value: string, enable = true) => {
	const textAreaRef = useRef<HTMLTextAreaElement>(null);

	useEffect(() => {
		if (textAreaRef && textAreaRef.current && enable) {
			textAreaRef.current.style.height = '0px';
			const scrollHeight = textAreaRef.current.scrollHeight + 14;
			textAreaRef.current.style.height = scrollHeight + 'px';
			textAreaRef.current.style.resize = 'none';
		}
	}, [enable, textAreaRef, value]);

	return textAreaRef;
};

export default useTextAreaAutoHeight;
